import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "description" }
const _hoisted_4 = {
  key: 0,
  class: "phonetic"
}

import { computed } from "vue";
import AudioComp from "@/views/AIGenerate/components/AudioComp.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'wordShow',
  props: {
    name: { default: "" },
    phonetic: { default: "" },
    definition: { default: "" },
    root: { default: "" }
  },
  setup(__props: any) {

const props = __props;
const title = computed(() =>
  props.name.replace(
    props.root.replace("-", ""),
    `<span style="color: #FF5323;">${props.root.replace("-", "")}</span>`
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "word",
      innerHTML: title.value
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.definition), 1),
    (props.phonetic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(props.phonetic) + " ", 1),
          _createVNode(AudioComp, {
            word: props.name,
            class: "audio"
          }, null, 8, ["word"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})